export default __webpack_public_path__ + "static/media/paper-plane.f069db85.svg";